import styled from "styled-components";

import { colors, radii } from "shared/ui";

export const Total = styled.div`
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    gap: 12px;
    padding: 14px 16px;
    border-radius: ${radii.base};
    background: ${colors.segmentBg};
`;

export const TotalLabel = styled.span`
    font-size: 14px;
    color: ${colors.textSecondary};
`;

export const TotalValue = styled.span`
    font-size: 1.125rem;
    font-weight: 600;
    color: ${colors.textPrimary};
`;

export const OfferRow = styled.div`
    font-size: 14px;
    color: ${colors.textSecondary};

    a {
        color: ${colors.primary};
    }
`;
